/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Col_BystepInputs */

const en_cmp_col_bystep = /** @type {(inputs: Cmp_Col_BystepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep`)
};

const id_cmp_col_bystep = /** @type {(inputs: Cmp_Col_BystepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep`)
};

/**
* | output |
* | --- |
* | "Bystep" |
*
* @param {Cmp_Col_BystepInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_col_bystep = /** @type {((inputs?: Cmp_Col_BystepInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Col_BystepInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_col_bystep(inputs)
	return en_cmp_col_bystep(inputs)
});